import { render, staticRenderFns } from "./settingDsShop.vue?vue&type=template&id=003cf90f&scoped=true"
import script from "./settingDsShop.vue?vue&type=script&lang=js"
export * from "./settingDsShop.vue?vue&type=script&lang=js"
import style0 from "./settingDsShop.vue?vue&type=style&index=0&id=003cf90f&prod&lang=less&scoped=true"
import style1 from "./settingDsShop.vue?vue&type=style&index=1&id=003cf90f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003cf90f",
  null
  
)

export default component.exports